<app-dialog [title]="'Account Detail'" (close)="close()" (action)="action($event)" [actions]=" [{ text: 'Cancel', buttonStyle: 'underline' }, { text: 'Save',isDisabled: form.invalid || spin, spin: spin}]">
    <div class="account-detail" [ngClass]="{'account-detail--amazon': data.account.type == 'Amazon' ,
     'account-detail--amazon-auth': data.account.type == 'Amazon' }">
        <div [formGroup]="disabledForm" style="display: contents;">
            <div class="input-container">
                <label for="" class="input-container_label">Name: </label>
                <input type="text" class="input-container_input" formControlName="name" />
            </div>

            <div class="input-container">
                <label for="" class="input-container_label">Seller ID: </label>
                <input type="text" class="input-container_input" formControlName="seller" />
            </div>

            <div class="input-container">
                <label for="" class="input-container_label">Marketplace ID: </label>
                <input type="text" class="input-container_input" formControlName="marketplaceID" />
            </div>
        </div>

        <div class="input-container input-container--authentication" *ngIf="data.account.type == 'Amazon' ">
            <label class="input-container_label mb-3">Authentication </label>
            <div class="connection_authentication">
                <div class="connection_authentication--action mb-2" [ngClass]="{'not-completed': !data.account.isActive}"> Amazon                   
                </div>
                <div *ngIf="user.isNetYard || isPlanyard == 1" class="connection_authentication--action" [ngClass]="{'not-completed': !data.ppcToken}"> PPC 
                    </div>
                </div>
        </div>

        <div [formGroup]="form" style="display: contents;">
            <div style="display: contents;" *ngIf="data.account.type == 'Amazon'">
                <div class="input-container input-container--auth">
                    <label for="" class="input-container_label">MWS Auth Token: </label>
                    <input type="text" class="input-container_input" formControlName="mwsToken" />
                </div>
            </div>

            <app-page-container-devider
                [title]="'Inventory sync setup'"
                [small]="true"
                [class]="'devider'"
            ></app-page-container-devider>

            <div class="input-container  input-container--sync">
                <label for="" class="input-container_label">
                    <mat-slide-toggle formControlName="syncInventory" class="me-2">Sync inventory</mat-slide-toggle>
                </label>
            </div>
    
            <div class="input-container">
                <label for="" class="input-container_label custom_label">Percent to Sync: </label>
                <div class="input-container_wrapper">
                    <input type="number" class="input-container_input  input-container_input--number" formControlName="syncPct" />
                    <span class="input-container_icon">
                        <i class="fa fa-percent"></i>
                    </span>
                </div>
            </div>

            <div class="input-container">
                <label for="" class="input-container_label">Safety Stock: </label>
                <input type="number" class="input-container_input" formControlName="safetyStock" />
            </div>
    
            <div class="input-container">
                <label for="" class="input-container_label">Default Max:
                    <i class="input-container--fa-info-circle fas fa-info-circle"
                 matTooltip="Leave blank if there's no max"
                ></i> </label>
                <input type="number" class="input-container_input" formControlName="defaultMax" />
            </div>
    
            <div class="input-container  mt-2">
                <label for="" class="input-container_label">Handling Time: 
                <i class="input-container--fa-info-circle fas fa-info-circle" *ngIf="data.account.type == 'Amazon'"
                 matTooltip="If left empty, the current skus' handling time will be overridden and removed when updating qty"
                ></i> </label>
                <input type="number" class="input-container_input" formControlName="hanldingTime" />
            </div>
            
            
            <app-page-container-devider
                [title]="'Other Settings'"
                [small]="true"
                [class]="'other mt-4'"
            ></app-page-container-devider>

            <div class="input-container  input-container--deduct mb-0">
                <label for="" class="input-container_label mb-0">
                    <mat-slide-toggle formControlName="deductStock">Deduct stock for merchant fulfilled orders</mat-slide-toggle>
                </label>
            </div>
            <div class="input-container input-container--toggle mb-0" *ngIf="data.accountRegionId == 1">
                <label for="" class="input-container_label mb-0">
                    <mat-slide-toggle formControlName="includeNarfOrders">Calculate all North American orders into the US calculations</mat-slide-toggle>
                </label>
            </div>
            <div class="input-container input-container--warehouse">
                <label for="" class="input-container_label">Default ship from warehouse: </label>
                <select type="text" class="input-container_input" formControlName="defaultWarehouseId" placeholder="Select warehouse">
                    <option [value]="''">Select</option>
                    <option *ngFor="let warehouse of warehouses" [value]="warehouse.id">{{warehouse.id}}</option>
                </select>
            </div>
            <div class="input-container input-container--deductDropdown" >
                <label for="" class="input-container_label"> Default Deduct from: </label>
                <select type="text" class="input-container_input" formControlName="deductWarehouseId" placeholder="Select warehouse">
                    <option [value]="''">Select</option>
                    <option *ngFor="let warehouse of warehouses" [value]="warehouse.warehouseId">{{warehouse.id}}</option>
                </select>
            </div>
        </div>


    </div>

</app-dialog>
